const ACTIVE_SEGMENT_CLASS = 'is-active';

const SCROLL_EDGE_TOLERANCE_PIXELS = 2;

function getActiveSegmentIndex(scrollLeft, scrollWidth, clientWidth, segmentCount) {
  if (segmentCount < 1) return -1;

  const maxScrollLeft = scrollWidth - clientWidth;

  if (maxScrollLeft <= SCROLL_EDGE_TOLERANCE_PIXELS) return -1;

  const distanceFromStart = Math.abs(scrollLeft);

  if (distanceFromStart <= SCROLL_EDGE_TOLERANCE_PIXELS) return 0;
  if (distanceFromStart >= maxScrollLeft - SCROLL_EDGE_TOLERANCE_PIXELS) return segmentCount - 1;

  return Math.floor(segmentCount / 2);
}

function getActiveSegmentIndexForCarousel(index, endIndex, isLooped, segmentCount) {
  if (segmentCount < 1) return -1;
  if (isLooped) return -1;
  if (endIndex < 1) return -1;

  if (index <= 0) return 0;
  if (index >= endIndex) return segmentCount - 1;

  return Math.floor(segmentCount / 2);
}

function initScrollIndicator(indicatorElement) {
  const scrollerId = indicatorElement.getAttribute('data-kl-scroll-indicator');

  if (!scrollerId) {
    console.debug('kl-scroll-indicator: the hook names no scroller', { indicatorElement });
    return;
  }

  const scrollerElement = document.getElementById(scrollerId);

  if (!scrollerElement) {
    console.debug('kl-scroll-indicator: no element with that id', { scrollerId });
    return;
  }

  const segmentElements = indicatorElement.querySelectorAll('[data-kl-scroll-indicator-segment]');

  if (!segmentElements.length) {
    console.debug('kl-scroll-indicator: the indicator has no segments', { scrollerId });
    return;
  }

  function updateActiveSegment() {
    if (scrollerElement.classList.contains('is-active')) return;

    showActiveSegment(
      getActiveSegmentIndex(
        scrollerElement.scrollLeft,
        scrollerElement.scrollWidth,
        scrollerElement.clientWidth,
        segmentElements.length
      )
    );
  }

  function showActiveSegment(activeSegmentIndex) {
    indicatorElement.hidden = activeSegmentIndex < 0;

    segmentElements.forEach((segmentElement, segmentIndex) => {
      segmentElement.classList.toggle(ACTIVE_SEGMENT_CLASS, segmentIndex === activeSegmentIndex);
    });
  }

  function handleCarouselMoved(event) {
    const position = event.detail;

    if (!position) return;

    showActiveSegment(
      getActiveSegmentIndexForCarousel(
        position.index,
        position.endIndex,
        position.isLooped,
        segmentElements.length
      )
    );
  }

  scrollerElement.addEventListener('kl:carousel:moved', handleCarouselMoved);
  scrollerElement.addEventListener('scroll', updateActiveSegment, { passive: true });

  if (typeof ResizeObserver === 'function') {
    new ResizeObserver(updateActiveSegment).observe(scrollerElement);
  }

  updateActiveSegment();
}

document.querySelectorAll('[data-kl-scroll-indicator]').forEach(initScrollIndicator);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-kl-scroll-indicator]').forEach(initScrollIndicator);
});
